import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';
import React from 'react';

import { TOP_BAR_HEIGHT } from '@/components/layout/topBar/TopBar.styles.ts';
import { themeColors } from '@/config/theme/themeColors.ts';

export const PageLoading: React.FC = () => {
  return (
    <Stack
      sx={{
        alignContent: 'center',
        height: `calc(100vh - ${TOP_BAR_HEIGHT})`,
        justifyContent: 'center',
        width: '100%',
      }}
    >
      <Box
        sx={{
          margin: 'auto',
        }}
      >
        <CircularProgress size="80px" sx={{ color: themeColors.accentColor }} />
      </Box>
    </Stack>
  );
};
